const CountrySelector = ({
  selectedCountry,
  setSelectedCountry,
  isOpen,
  setIsOpen,
  countries,
}) => {
  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 rounded-full p-1.5 md:p-2 text-sm border border-b-0 border-[#87CA60]/60 bg-white drop-shadow-md min-w-16"
      >
        <img
          src={countries.find((c) => c.name === selectedCountry)?.flag || "/placeholder.svg" || "/placeholder.svg"}
          alt={selectedCountry}
          loading="lazy"
          className="w-7 h-7 md:w-6 md:h-6 rounded-full object-cover border border-slate-300"
        />
        <span className="hidden md:flex">{selectedCountry}</span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-[170px] bg-white border rounded-lg shadow-lg py-1 z-10">
          {countries.map((country) => (
            <button
              key={country.name}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-100 flex items-center space-x-2 ${
                selectedCountry === country.name ? "bg-gray-50" : ""
              }`}
              onClick={() => {
                setSelectedCountry(country.name)
                setIsOpen(false)
              }}
            >
              <img
                src={country.flag || "/placeholder.svg"}
                alt={country.name}
                loading="lazy"
                className="w-5 h-5 rounded-full object-cover"
              />
              <span>{country.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default CountrySelector

